import React from 'react';

export default function User() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M7 7C7.82426 7 8.53801 6.70436 9.12119 6.12107C9.70437 5.53787 10 4.82429 10 3.99991C10 3.17581 9.70437 2.46213 9.1211 1.87874C8.53782 1.29564 7.82417 1 7 1C6.17564 1 5.46208 1.29564 4.8789 1.87884C4.29572 2.46204 4 3.17571 4 3.99991C4 4.82429 4.29572 5.53796 4.879 6.12116C5.46227 6.70427 6.17593 7 7 7Z'
        fill='#A4A4A4'
      />
      <path
        d='M12.9709 10.8714C12.9515 10.6075 12.9122 10.3197 12.8544 10.0158C12.796 9.70961 12.7208 9.42014 12.6308 9.15558C12.5379 8.88213 12.4115 8.61209 12.2552 8.35331C12.093 8.08471 11.9025 7.85083 11.6888 7.65837C11.4652 7.45702 11.1916 7.29514 10.8751 7.17707C10.5597 7.05961 10.2102 7.0001 9.83633 7.0001C9.6895 7.0001 9.54751 7.05682 9.27328 7.2249C9.1045 7.32851 8.90709 7.44835 8.68674 7.58089C8.49833 7.6939 8.24308 7.79979 7.92781 7.89566C7.62022 7.98936 7.30792 8.03688 6.99967 8.03688C6.69142 8.03688 6.37923 7.98936 6.07131 7.89566C5.75637 7.7999 5.50112 7.69401 5.31293 7.58099C5.09467 7.44969 4.89714 7.32986 4.72584 7.22479C4.45195 7.05671 4.30984 7 4.16301 7C3.78903 7 3.43964 7.05961 3.12437 7.17717C2.80811 7.29504 2.53432 7.45692 2.31057 7.65847C2.09691 7.85103 1.9063 8.08481 1.74433 8.35331C1.58818 8.61209 1.46177 8.88202 1.36871 9.15568C1.27884 9.42025 1.20367 9.70961 1.14529 10.0158C1.08746 10.3193 1.04817 10.6072 1.02875 10.8717C1.00966 11.1308 1 11.3997 1 11.6713C1 12.3781 1.23867 12.9503 1.70933 13.3723C2.17417 13.7887 2.78923 14 3.53719 14H10.4628C11.2108 14 11.8256 13.7888 12.2906 13.3723C12.7613 12.9506 13 12.3783 13 11.6712C12.9999 11.3983 12.9901 11.1292 12.9709 10.8714Z'
        fill='#A4A4A4'
      />
    </svg>
  );
}
